import { render } from "./o2-saturation.vue?vue&type=template&id=41687a9c&scoped=true"
import script from "./o2-saturation.vue?vue&type=script&lang=js"
export * from "./o2-saturation.vue?vue&type=script&lang=js"

import "./o2-saturation.vue?vue&type=style&index=0&id=41687a9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41687a9c"]])

export default __exports__